

const theme = {
  page: {
    backgroundColor: '#ffffff', // fondo blanco (bgwhite)
    inset: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',   // alinear la tarjeta al inicio para que el contenido se expanda hacia abajo
    justifyContent: 'center',
    paddingTop: 28,
    paddingLeft: 28,   // nuevo: padding horizontal izquierdo
    paddingRight: 28,  // nuevo: padding horizontal derecho
            // un poco más de padding superior
    fontFamily: "'IBM Plex Mono', monospace",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    overflowY: 'auto',          // permitir scroll vertical cuando sea necesario
    position: 'relative', // asegurar contexto para GridBackground absoluto
  },
  card: {
    width: '100%',
    maxWidth: 420,
    background: 'transparent', // dejar transparente para que se vea la cuadricula
    borderRadius: 20,
    padding: 20,
    boxSizing: 'border-box',
    boxShadow: 'none',
    zIndex: 1, // asegurar que la tarjeta esté encima del fondo
    color: '#000',
    marginTop: 0, // separación desde la parte superior; contenido empuja hacia abajo al crecer
    marginBottom: 0, // algo de espacio inferior para cuando haga scroll
  },
};
export default theme;
